import React, {Fragment} from 'react';
import {Flex, Breadcrumbs, Layout, Button, Separator, Textarea, List} from 'components';
import {moment, useNamedSelector} from "helpers";
import {WeeklyObjectiveCard} from "./weekly-objective-card";

export function PlanMyWeekActivities() {

  const { firstDayOfWeek } = useNamedSelector('settings.settings');
  moment.updateLocale('en', {
    week: {
      dow: firstDayOfWeek - 1 // 1 = Sunday, 2 = Monday
    }
  });
  const startOfWeek = moment().startOf('week');
  const endOfWeek = moment().endOf('week');

  const weeklyObjectives = useNamedSelector('goals.weeklyObjectivesList', {
    module: 'goals',
    filter: useNamedSelector('settings.shareStatusFilter', {context: 'goals'})
  });

  const filteredWeeklyObjectives = weeklyObjectives.filter(objective => {
    const targetDate = moment.unix(objective.target_date);
    return targetDate.isBetween(startOfWeek, endOfWeek, 'day', '[]');
  });

  return (
    <>
      <Layout.Header>
        <Flex>
          <div className="pull-left">
            <Breadcrumbs>
              <b>Add Activities</b>
            </Breadcrumbs>
          </div>
          <Button to="/today/plan-my-week/start" className={['small', 'borderless']} icon="return">Back</Button>
          <Button className={['primary', 'small']} to="/today/plan-my-week/reflections" rightIcon="arrow-right">Next</Button>
        </Flex>
      </Layout.Header>
      <div className="sticky-container">
        <List tiny-gutter>
          <Fragment>
            <Flex className="medium-spacing">
              Tap + to add all Activities that are necessary to achieve each Weekly Objective.
            </Flex>
            <Separator className="medium">
              <u/>
            </Separator>
          </Fragment>
        </List>
        <Layout.Sidebar.Scrollable>
          {filteredWeeklyObjectives.map(goal => goal.heading !== undefined
            ? <Separator key={goal.heading} heading={goal.heading}/>
            : <WeeklyObjectiveCard id={goal.id} key={goal.id} disabled={true} />
          )}
        </Layout.Sidebar.Scrollable>
      </div>
    </>
  )
}
